import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";

@Injectable()
export class ConfigLoyaltyService {
  headers: Headers;
  url = environment.qrcode_url;
  url_aps = environment.qrcode_url_aps;

  constructor(private http: Http) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  box(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/box`, body, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // đóng thùng ở màn kiểm tra tem thùng
  cratingBoxStamp(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/box/add`, body, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  stampValidate(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/stamp/validate`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  stampGroupValidate(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/stamp/validate/group`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  boxValidate(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/validate`, { headers: this.headers, params: query })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  listBoxType(): Observable<any> {
    return this.http
      .get(`${this.url}/box/type`, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }
  detailStamp(id): Observable<any> {
    return this.http
      .get(`${this.url}/mobile/scan/decode?code=${id}`, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  getListCampaignLoyalty(query?: any): Observable<any> {
    return this.http
      .get(`${this.url_aps}/loyalty/campaigns`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  configLoyalty(body?: any): Observable<any> {
    return this.http
      .post(`${this.url_aps}/loyalty/campaigns`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  validateStampLoyalty(body?: any): Observable<any> {
    return this.http
      .post(`${this.url_aps}/loyalty/campaigns/validate/stamp`, body, {
        headers: this.headers
      })
      .map((res) => {
        return res.json();
      }).catch((error) => {
        throw error.json()
      })
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty/config-loyalty/services/config-loyalty.services.ts